<nav class="navbar navbar-expand-lg text-white navbar-dark bg-dark p-0">
    <div class="container-fluid p-0">
        <a class="navbar-brand" routerLink="/admin">
            <img ngSrc="../../../assets/images/SJP_logo.svg" alt="SJP Logotyp" class="navbar-logo p-4" height="353"
                 width="684"/>
        </a>

        <h3 class="navbar-text text-light fw-bold mb-0">Tåg i tid</h3>

        <button class="navbar-toggler" type="button" (click)="isNavMenuCollapsed = !isNavMenuCollapsed">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div [ngbCollapse]="isNavMenuCollapsed" class="collapse navbar-collapse" id="navbarTop">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <div class="d-flex align-items-center">
                        <mat-icon class="me-2" fontIcon="person"/>
                        <span>{{ userNameAndEmail }}</span>
                        <button matTooltip="Logga ut" mat-icon-button (click)="logout()">
                            <mat-icon fontIcon="logout_icon"/>
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>

<router-outlet />
